import { GIFT_REGISTRY_WIDGET_NAMES } from "@/constants/widget-names";
import { SharedRegistryPageWidgetDefinition } from "@apps/gift_registry/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class SharedRegistryPageWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug(`${SharedRegistryPageWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                `${SharedRegistryPageWidgetInjector.name} found placeholder`,
                placeholder
            );

            const widgetName =
                GIFT_REGISTRY_WIDGET_NAMES.SHARED_REGISTRY_PAGE_WIDGET;

            void (async () => {
                const SharedRegistryPageWidget =
                    await this.dynamicImportManager.importDefault(
                        SharedRegistryPageWidgetDefinition,
                        true
                    );

                const widget = new SharedRegistryPageWidget(
                    {
                        target: placeholder,
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(widgetName)
                );

                dispatchSdkEvent(new WidgetInjectedSdkEvent(widgetName));
            })();
        });
    }
}

export default SharedRegistryPageWidgetInjector;
